module.exports = __webpack_public_path__ + "static/media/wizualizacja-9.e8d1b65c.png";